import { IReactiveNewsContentItem } from "../SchoolFeedContentItem";
import { useStores } from "../../../stores/useStores";
import {
  buildContentItemUrl,
  isSchoolFeedStandalone,
} from "../../../utils/SchoolBlocksUtilities";
import { meritChatID } from "../../modals/NewsModal/NewsModalContent";
import { extractNumber } from "../../../utils/StringUtilities";
import variables from "../../../styles/_variables.module.scss";
import ClickableLink from "../../utilities/ClickableLink";
import classNames from "classnames";
import styles from "./styles/ListItemGroup.module.scss";
import { useTranslation } from "react-i18next";

export const JoinDiscussionButton = (props: {
  itemObj: IReactiveNewsContentItem;
  className?: string;
}) => {
  const { t } = useTranslation("translation", {
    lng: props.itemObj.language || "",
  });
  const { organizationStore } = useStores();
  const schoolFeedStandalone = isSchoolFeedStandalone();

  const schoolFeedLink = schoolFeedStandalone
    ? ""
    : organizationStore.organization.schoolfeed_hostname +
      buildContentItemUrl(props.itemObj.organization_id, props.itemObj.id);

  const handleClick = () => {
    // Need to delay scroll to account for modal transition time
    setTimeout(
      () => {
        const el = document.getElementById(meritChatID);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      },
      extractNumber(variables["modal-transition-time"]) + 250,
    );
  };

  return (
    <ClickableLink
      aria-label={"Link to content item page"}
      onClick={schoolFeedStandalone ? handleClick : (e) => e.stopPropagation()}
      href={schoolFeedLink}
      className={classNames(styles.joinTheDiscussion, props.className)}
    >
      <>
        <span className={styles.joinTheDiscussionFullText}>
          {t("Join Discussion")}
        </span>
        <span className={styles.joinTheDiscussionShortText}>
          {t("Discuss")}
        </span>
      </>
    </ClickableLink>
  );
};
